module.exports = __webpack_public_path__ + "static/project-4-3-9d87a0d8c6e3e2c62d16a7ba406ec435.jpg";